import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

export const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-text_muted">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Global guard: any account with an explicit email_verified=false
  // (Google accounts and legacy pre-migration accounts are never set to
  // false, so they're never affected) is sandboxed to the dedicated
  // verification page — no protected route renders for them at all.
  if (user.email_verified === false && location.pathname !== '/verification-requise') {
    return <Navigate to="/verification-requise" replace />;
  }

  if (adminOnly && user.role !== 'admin' && user.role !== 'moderator') {
    toast.error('Access restricted.');
    return <Navigate to="/" replace />;
  }

  return children;
};
